<template>
    <v-container class="pa-0">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card flat>
                    <v-card-title>
                        <v-btn small flat @click="offset-=limit, getnotes()" :disabled="offset<=0" >
                            <v-icon>arrow_left</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        [{{offset}} - {{offset+notes.length}}]
                        <v-spacer></v-spacer>
                        <v-btn small flat @click="offset+=limit, getnotes()" :disabled="this.notes.length<limit" >
                            <v-icon>arrow_right</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-list two-line>
                        <v-list-tile @click="noteindex=i, load()" avatar v-for="n,i in notes">
                            <v-list-tile-avatar size="40">
                                <img v-if="n.locationframe" :src="n.locationframe" />
                                <v-icon v-else class="grey lighten-1 white--text">{{n.icon}}</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{n.note}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{n.displayDate}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>
        <!--<v-data-table-->
                <!--:headers="headers"-->
                <!--:items="notes"-->
                <!--class="elevation-1"-->
        <!--&gt;-->
            <!--<template slot="items" slot-scope="props">-->
                <!--<tr @click="loadvideo(props.index)">-->
                    <!--<td class="text-xs-right tde">{{ props.item.note }}</td>-->
                    <!--<td class="text-xs-right">{{ props.item.createdAt }}</td>-->
                <!--</tr>-->
            <!--</template>-->
        <!--</v-data-table>-->
        <v-dialog v-model="dialog" persistent :fullscreen="$vuetify.breakpoint.name=='xs'" max-width="720">
            <v-card>
                <v-card-title>
                    <v-btn flat @click="closenote()">close</v-btn>
                    <v-spacer></v-spacer>
                    {{note.displayDate}}
                </v-card-title>
                <div v-if="note.code=='video'">
                    <video ref="video"  preload="metadata" style="width:100%;" :key="src+note.id">
                        <source :src="src" type="video/mp4">
                    </video>
                </div>
                <div v-if="note.code=='text'">
                    <v-card-text class="headline">{{note.note}}</v-card-text>
                </div>
                <v-layout row>
                    <v-flex xs2>
                        <v-btn flat @click="prev()" :disabled="noteindex<=0" ><v-icon>arrow_left</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs2 v-if="note.code=='video'">
                        <v-btn flat @click="play()" v-if="!playing"><v-icon>play_arrow</v-icon></v-btn>
                        <v-btn flat @click="pause()" v-else><v-icon>pause</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs2 v-if="note.code=='video'">
                        <v-btn flat @click="replay()"><v-icon>replay</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs2 v-if="note.code=='video'">
                        <v-btn flat @click="slowplay = !slowplay, toggleslow()">
                            <span v-if="slowplay">1x</span>
                            <span v-else>.5x</span>
                        </v-btn>
                    </v-flex>
                    <v-flex xs6 v-if="note.code=='text'"></v-flex>
                    <v-flex xs2>
                        <v-btn flat @click="next()" :disabled="this.noteindex>=(notes.length-1)"><v-icon>arrow_right</v-icon></v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    //PASS $STORE VARIABLES NEEDED, AS PROPS. SO WE CAN USE THIS CROSS PROJECTS..
    //NEED TO IMPORT FROM GIT.
    //import VideoNote from './VideoNote'
    export default {
        //components: {VideoNote},
        name: "Notepad",
        props:['bookkey','api','videourl','title','path'],//path = org or tag
        data() {
            return {
                dialog:false,
                headers:[
                    { text: 'Note', value: 'note' },
                    { text: 'Date', value: 'createdAt' },
                ],
                notes:[],
                noteindex:0,
                note:{
                    id:0,
                    playbackrate:0,
                    videotimestamp:0,
                    duration:0
                },
                offset:0,
                limit:8,
                noteid:'',
                src:'',
                video:'',
                slowplay:false,
                videoloop:'',
                loading:true,
                playing:false,
            }
        },
        mounted() {
            this.getnotes()
        },
        methods: {
            load(){
                console.log(this.noteindex)
                this.note=this.notes[this.noteindex]
                this.dialog=true;
                if(this.note.code==='video' ){
                    this.loadvideo()
                } else if(this.note.code==='text') {
                    this.loadtext()
                } else {
                    return;
                }
            },
            loadvideo(){
                let em = this;
                this.note = this.notes[this.noteindex];
                let options = {
                    method:'GET',
                    headers:{
                        'Accept' : 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
                fetch(this.api+'api/video/get/'+this.note.partkey+'/'+this.note.sortkey, options)
                    .then((response)=> response.json() )
                    .then((res)=>{
                        if(em.src!==em.videourl + res.Item.info.url720p){
                            em.src = em.videourl + res.Item.info.url720p;
                        }
                        em.loadtexttrack()
                    }).catch(e=>console.log(e))
            },
            loadtext(){
                this.note = this.notes[this.noteindex];
            },
            getnotes(){
                let em = this;
                let options = {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
                fetch(this.api+'api/notes/'+[this.path]+'/'+this.bookkey+'?offset='+this.offset,options)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                        em.notes = response
                        window.localStorage.setItem('notes',JSON.stringify(response))
                    }).catch(e=>{console.log(e)})
            },
            loadtexttrack(){
                //this is called from the watch() method... might be able to change it at this point...
                let em = this;
                em.loading = true;
                this.$nextTick(function(){
                    let video = this.$refs.video,track
                    let stamp = parseFloat(this.note.videotimestamp)
                    let dur = parseFloat(this.note.duration)
                    let end = parseFloat(stamp+dur)
                    video.currentTime = this.note.videotimestamp;
                    track = video.addTextTrack("captions", "English", "en");
                    track.mode = "showing";
                    track.addCue(new VTTCue(
                        stamp,
                        end,
                        this.note.note))
                    em.play()
                    this.videoloop = setInterval(function(){
                        if(video.currentTime > end){
                            video.currentTime = stamp;
                        }
                    },100);
                    // this.tracks.forEach((t)=>{
                    //     track.addCue(new VTTCue(t.s,t.t,t.txt))
                    // })
                })
            },
            closenote(){
                this.dialog=false
                if(this.note.code==='video') this.pause();
            },
            replay(){
                this.$refs.video.currentTime = this.note.videotimestamp
            },
            toggleslow(){
                if(this.slowplay==true){
                    this.$refs.video.playbackRate = .4
                } else {
                    this.$refs.video.playbackRate = 1
                }
            },
            play(){
               this.slowplay = false;
               this.$refs.video.playbackRate=this.note.playbackrate;
               this.$refs.video.play();
               this.playing=true;
            },
            pause(){
               this.$refs.video.pause();
               this.playing=false;
            },
            prev(){
                this.noteindex--
                this.load()
            },
            next(){
                this.noteindex++
                this.load()
            },
            startloop(location,endtime,duration){
                this.$refs.vp.load();
                let em = this;
                this.playback(0.5);
                em.$refs.vp.currentTime = location;
                let vid = em.$refs.vp;
                this.videoloop = setInterval(function(){
                    if(vid.currentTime > endtime){
                        em.$refs.vp.currentTime = location;
                    }
                },100);


            },
        }
    }
</script>

<style scoped>
    .tde{
        width:50%;
        overflow: hidden;
    }
</style>